// Canonical action keys. Mirror of backend/internal/platform/auth/actions.go.
// Keep in sync — adding/removing an action requires editing BOTH files.
// (A future codegen step from openapi.yaml could automate this; manual is
// fine for the frontend-used subset with low churn.)

export const ACTION = {
  // Audit / Settings / HR / Misc
  AuditRead: "audit.read",
  // Sao kê ngân hàng. Bốn quyền, ba mức mở khác nhau — đừng gộp:
  // `List` là xem CẢ sao kê (số dư, mọi giao dịch, kể cả không liên quan
  // đơn nào) nên chỉ kế toán/giám đốc/admin. `Lookup` và `Propose` mở rộng
  // cho người bán hàng, nhưng backend chỉ trả về vài dòng khớp với ĐÚNG một
  // đơn họ hỏi — không phải cửa sau vào sao kê. `Approve` cố ý hẹp bằng
  // `List`: người tìm ra khoản tiền KHÔNG được là người chốt nó thuộc đơn nào.
  BankTxList: "banktx.list",
  BankTxLookup: "banktx.lookup",
  BankTxPropose: "banktx.propose",
  BankTxApprove: "banktx.approve",
  BusinessPlanWrite: "businessplan.write",
  BusinessPlanRead: "businessplan.read",
  RetouchQueueRead: "retouch.queue.read",
  RetouchAnalyticsRead: "retouch.analytics.read",
  HrWrite: "hr.write",
  // QĐ 0289 (04/10/2026): gửi / rút / xem yêu cầu đổi hồ sơ gửi HR duyệt.
  HrChangeRequestWrite: "hr.change_request.write",
  BranchRead: "branch.read",
  BranchWrite: "branch.write",
  // Chỉ đọc (QĐ 0516): phạm vi chi nhánh từng người do HRM ghi.
  BranchScopeRead: "branch_scope.read",
  StaffCheckinRead: "staff_checkin.read",
  // Sửa giờ / thêm lượt chấm công văn phòng / từ xa (QĐ 0182) — nút "Sửa giờ"
  // và "Thêm lượt chấm công" ở màn Chấm công (features/checkin).
  StaffCheckinAdjust: "staff_checkin.adjust",
  // Sửa giờ tính công / thêm lượt chấm công TẠI CƠ SỞ (QĐ 0442) — Trưởng cửa
  // hàng, Trưởng ca, giám đốc; cùng hai nút ở màn Chấm công.
  StaffCheckinAdjustBranch: "staff_checkin.adjust_branch",
  CatalogWrite: "catalog.write",
  SettingsWrite: "settings.write",
  SettingsBankInfoWrite: "settings.bank_info.write",
  SettingsConceptGuidesWrite: "settings.concept_guides.write",
  CatalogConceptsWrite: "catalog.concepts.write",
  SettingsZaloTemplatesWrite: "settings.zalo_templates.write",
  TelegramAdmin: "telegram.admin",
  // Chat khách (/customer-chats) — HAI quyền, hai câu hỏi khác nhau
  // (quyết định 0062, 30/08/2026):
  //   · CustomerChatAdmin = thấy MỌI khách + được mở kênh realtime. Quản trị
  //     và giám đốc. Kênh đẩy tin của mọi phiên nên cố ý hẹp.
  //   · CustomerChatRead  = vào được trang; ai thấy khách nào do máy chủ cắt
  //     (trưởng cửa hàng theo cơ sở, lễ tân ảnh thẻ, CSKH profile). Lễ tân và
  //     CSKH mang vai `staff` nên KHÔNG có quyền này — họ vào theo phòng ban,
  //     xem canManageCustomerChats.
  CustomerChatAdmin: "customer_chat.admin",
  CustomerChatRead: "customer_chat.read",
  //   · CustomerChatTagManage = sửa DANH MỤC thẻ phân loại dùng chung (thêm,
  //     đổi tên/màu, xoá, sắp xếp — QĐ 0135). Gắn/gỡ thẻ và ghim thì ai vào
  //     được hộp thư đều làm được, không cần quyền này.
  CustomerChatTagManage: "customer_chat.tag.manage",

  // Promo (mã khuyến mãi/đồ tặng/định mức) — bảng riêng từ migration 0059,
  // không còn nằm dưới settings.promo_codes JSONB blob. Hẹp hơn giá trị cũ
  // (admin/director/sale) — sale không còn quản trị promo trực tiếp.
  PromoWrite: "promo.write",

  // Xem trang Ưu đãi + chi tiết mã + lịch sử + khối số liệu Giờ Vàng. Admin/
  // giám đốc có theo vai trò; leader Sale và leader Marketing được BE cấp theo
  // phòng (grantPromoReadToSalesMarketingLeaders) — leader phòng khác KHÔNG
  // có, vì màn này lộ số tiền giảm giá.
  PromoRead: "promo.read",
  // Tra mã còn hạn (GET /promos/lookup, G5 — quyết định 7a): mọi vai bán
  // hàng; chỉ mã, mức giảm, gói áp, hạn dùng — không định mức, không lượt dùng.
  PromoLookup: "promo.lookup",
  StaffProfile360Read: "staff.profile360.read",
  StaffOffboardingTransfer: "staff.offboarding.transfer",

  // Dashboard
  DashboardRead: "dashboard.read",
  DashboardSensitiveRead: "dashboard.sensitive.read",

  // Affiliate (người giới thiệu + hoa hồng) — dựng trên hệ promo, migration
  // 0063. Kế toán ĐỌC và CHI được nhưng không sửa được hồ sơ/mức hoa hồng:
  // người chi tiền không phải người tự đặt ra số tiền mình chi.
  AffiliateRead: "affiliate.read",
  AffiliateWrite: "affiliate.write",
  AffiliatePayout: "affiliate.payout",
  // Báo cáo nguồn khách theo link UTM — marketing vào bằng cửa phòng ban ở
  // BE (AllowOrDept), action này chỉ cấp cho admin/giám đốc/kế toán.
  AffiliateSourceReport: "affiliate.source_report",
  /** Đọc/trả lời phiên chat của người giới thiệu & đối tác (spec 22/08/2026 §9.4). */
  AffiliateChat: "affiliate.chat",

  // KPI doanh thu chi nhánh — khớp backend actions.go. Đọc bị BranchScope
  // cắt phạm vi ở BE nên FE không cần lọc lại theo chi nhánh.
  KpiRead: "kpi.read",
  KpiTargetWrite: "kpi.target.write",
  KpiScopeWrite: "kpi.scope.write",
  // Định mức chi tháng tách RIÊNG khỏi KpiTargetWrite có chủ đích (quyết định
  // 0190): chỉ tiêu doanh thu là số giám đốc giao, định mức chi là số kế toán
  // nắm. Gộp hai ô vào một quyền thì hoặc kế toán sửa được chỉ tiêu chấm chính
  // cơ sở, hoặc kế toán không gõ được ô của mình — cả hai đều sai.
  KpiExpenseNormWrite: "kpi.expensenorm.write",

  // Quỹ thưởng vượt KPI. Xem tiền (KpiFundRead) hẹp hơn xem tiến độ một bậc:
  // trưởng chi nhánh có, sale và nhân viên thường không. Bấm ra tiền
  // (KpiFundWrite) chỉ kế toán/giám đốc/admin — trưởng chi nhánh KHÔNG có, vì
  // không ai được tự chốt tiền của chính mình. Gắn nút chốt vào KpiFundRead là
  // phá thẳng vào hàng rào đó.
  KpiFundRead: "kpi.fund.read",
  KpiFundWrite: "kpi.fund.write",

  // CSKH
  CskhWrite: "cskh.write",
  CskhComplaintWrite: "cskh.complaint.write",
  // Nút "Khách đẹp" ở màn Đơn hàng (hợp đồng khachdep.v1 §8). Quyền này chỉ
  // cấp cho vai quản lý trở lên; bảy phòng gặp khách đi qua nhánh phòng ban
  // ở route — xem features/beauty-nomination/permissions.ts.
  CustomerBeautyWrite: "customer.beauty.write",

  // Sổ tiếng khách (quyết định 0201). ĐÚNG HAI hằng: cửa nâng một dòng sổ thành
  // phiếu khiếu nại dùng lại CskhComplaintWrite ở trên, không khai hằng thứ ba —
  // máy chủ cũng chỉ đăng ký hai hành động, và hai bảng cho một hậu quả sẽ trôi lệch.
  FeedbackRead: "feedback.read",
  FeedbackWrite: "feedback.write",
  CskhMonthlyWrite: "cskh.monthly.write",
  // Ô "Cần xử lý bên Kế toán" ở trang Thanh toán (QĐ 0311 Câu 11a).
  SalesOrderRelayFlagsManage: "sales_order_relay.flags.manage",
  // Phòng Kinh doanh — cơ chế lương đội bán hàng từ 01/11/2026 (QĐ 0483). Vai chỉ
  // là cửa vào; ai duyệt / xem số tiểu đội nào do CHỨC trong cơ cấu quyết. Cơ cấu
  // sửa ở HRM (CEO 7b, 28/10/2026) — GNPF không có quyền sửa cơ cấu.
  SalesStructureRead: "sales.structure.read",
  SalesTargetManage: "sales.target.manage",
  SalesCreditPropose: "sales.credit.propose",
  SalesCreditConfirm: "sales.credit.confirm",
  SalesPayRead: "sales.pay.read",
  SalesPancakePropose: "sales.pancake.propose",
  SalesPancakeConfirm: "sales.pancake.confirm",
  SalesQualityRecord: "sales.quality.record",
  SalesCareMark: "sales.care.mark",
  // Tiểu đội Phòng KD (QĐ 0485): nhãn tiểu đội ở màn làm việc, bảng tiểu đội / miền, đặt tên
  // hiệu & logo & khung. Ai thấy tên sale / xem bảng / đặt / gỡ do PHÒNG + CHỨC quyết ở máy chủ.
  SalesSquadBadge: "sales.squad.badge",
  SalesSquadBoardRead: "sales.squad.board.read",
  SalesSquadBrand: "sales.squad.brand",
  // Nút "Gửi lại" yêu cầu duyệt chi đã vào hàng chết — phiếu hoàn (trang Thanh
  // toán) và lô hoa hồng (trang Người giới thiệu). Chỉ quản trị + giám đốc.
  FinanceApprovalResend: "finance_approval.resend",
  CskhPrintorderWrite: "cskh.printorder.write",
  // Khu giao vận đơn in (QĐ 0097): lễ tân/CSKH/hậu kỳ vai `staff` có
  // printops.read/write; đổi cơ sở nhận chỉ giám đốc. Rào phòng + cơ sở nhận
  // nằm ở BE — FE chỉ ẩn/hiện nút.
  PrintopsRead: "printops.read",
  PrintopsWrite: "printops.write",
  PrintopsReroute: "printops.reroute",
  // Cho in trước khi thu (gói D đợt 2 đơn in, M7): chỉ trưởng cửa hàng, giám
  // đốc, quản trị bật được cờ cho một đơn chưa thu đủ. SẮP dùng: nút "Cho in
  // trước khi thu" trên thẻ việc đơn in — gắn ở đợt màn, sau khi CEO duyệt
  // bản vẽ (kế hoạch 2026-10-11 gói D).
  PrintOpsPrintBeforePaid: "print.ops.print_before_paid",
  // Nhân viên bấm hộ "Khách đã duyệt mẫu" kèm ảnh tin nhắn khách (gói D đợt 2
  // đơn in, M8). SẮP dùng: hộp duyệt hộ kèm ảnh trên thẻ việc đơn in — gắn ở
  // đợt màn, sau khi CEO duyệt bản vẽ.
  PrintSampleApproveOnBehalf: "print.sample.approve_on_behalf",
  // Đối soát hoá đơn nhà in theo tháng (gói E đợt 2 đơn in, M18): quản trị, giám
  // đốc, kế toán. SẮP dùng: màn "Đối soát nhà in" của kế toán — gắn ở đợt màn,
  // sau khi CEO duyệt bản vẽ.
  PrintPrinterInvoiceManage: "print.printer_invoice.manage",
  // Báo cáo vận hành in (gói E đợt 2 đơn in, M19): quản trị, giám đốc, trưởng
  // cửa hàng (phạm vi cơ sở của mình). SẮP dùng: thẻ "Báo cáo" ở khu đơn in —
  // gắn ở đợt màn, sau khi CEO duyệt bản vẽ.
  PrintOpsReport: "print.ops.report",
  // "Khách báo lỗi sau khi nhận" (gói F đợt 2 đơn in, M20): mở lại món, trả nhà
  // in làm lại vòng bảo hành gắn phiếu khiếu nại. Lễ tân, CSKH, trưởng cửa hàng,
  // giám đốc, quản trị. SẮP dùng: nút trên thẻ việc đơn in đã giao — gắn ở đợt
  // màn, sau khi CEO duyệt bản vẽ.
  PrintOpsWarrantyReopen: "print.ops.warranty_reopen",
  // Sổ hậu mãi — chào khách mua thêm sau khi trả ảnh (spec 22/08/2026 §6).
  // BE gác bằng AllowOrDept("cskh.aftercare.write", "cskh", "reception") nên
  // CSKH/lễ tân vai `staff` vào được dù không có action này — FE phải hỏi qua
  // features/cskh/aftercarePermissions.ts, đừng gọi hasPermission trực tiếp.
  CskhAftercareWrite: "cskh.aftercare.write",
  // Danh mục bán thêm hợp nhất (settings `upsell_catalog`, quyết định 0043) —
  // PUT /upsell/catalog. BE: admin/director/manager, manager phải thuộc cskh
  // (handler kiểm dept). Action BE đã có sẵn từ trước (settings.cskh_upsale.write).
  SettingsCskhUpsaleWrite: "settings.cskh_upsale.write",
  // Xem danh sách khách tiềm năng — thẻ "Pipeline" của trang Đơn hàng
  // (QĐ 0160, CEO chốt 1a 17/09/2026). Tách khỏi cổng ghi vì trưởng cửa hàng
  // và nhân viên phòng marketing xem được mà không sửa được. Thẻ hiện theo
  // đúng quyền này, không theo bảng vai.
  SettingsSalesLeadsRead: "settings.sales_leads.read",
  CustomerBookingRead: "customer_booking.read",
  CustomerBookingManage: "customer_booking.manage",

  // Customer
  CustomerWrite: "customer.write",
  // Đổi SĐT / email khách — CENTER trước, GNPF sau (QĐ 0434). Quản trị + giám đốc.
  CustomerContactChange: "customer.contact_change",
  CustomerNoteList: "customer.note.list",

  // Ekip / Expense
  // EkipWrite = phân xử suất ê-kíp cho đơn + khoá tháng (ekip-pool).
  // EkipConfigWrite = bảng cấu hình ê-kíp dùng chung cả chuỗi (ekip-config).
  // Hai thứ khác nhau: xem ghi chú ở backend actions.go.
  EkipWrite: "ekip.write",
  EkipConfigWrite: "ekip.config.write",
  // Nhận ca HỘ thợ đã đi làm mà quên bấm (QĐ 0439): chưa nhận ca thì ca đó
  // không có lương. Trưởng cửa hàng / Giám đốc / Quản trị.
  EkipAcceptOnBehalf: "ekip.accept_on_behalf",
  ExpenseWrite: "expense.write",
  // Sổ chi phí là tiền: ĐỌC cũng qua cổng từ 13/09/2026 (QĐ 0132 §8 câu 4a) —
  // giám đốc, quản trị, kế toán, trưởng cửa hàng, quản lý cụm. Trang "Chi
  // phí" mở theo quyền này; vé chưa có claim mới (chưa đăng nhập lại sau
  // `casdoor-policy-sync`) thì máy chủ trả 403 và trang phải nói rõ.
  ExpenseRead: "expense.read",

  // Sổ tạm ứng nhân sự (migration 0352, QĐ 0189 §4). ĐỌC cùng bộ vai với sổ
  // chi vì mỗi dòng là tiền mang tên một người.
  //
  // QUYẾT TOÁN tách khỏi LẬP, cố ý: đóng dấu "đã thu lại" là một câu khẳng
  // định về tiền của người khác, nên nó không được nằm cùng tay người lập.
  AdvanceRead: "advance.read",
  AdvanceWrite: "advance.write",
  AdvanceSettle: "advance.settle",

  // Sổ hạn trọng yếu + đèn hệ thống (Đợt 1 kiểm soát brand).
  //
  // ĐỌC sổ hạn cũng cần quyền, cùng cách với sổ chi phí: sổ này mang điều
  // khoản thuê và tiền cọc của cả chuỗi.
  //
  // SystemHealthRead HẸP HƠN ObligationRead (3 vai so với 5): kế toán và
  // trưởng cửa hàng cần biết ngày hết hạn hợp đồng, nhưng sức khoẻ hạ tầng
  // là việc của người điều hành toàn chuỗi.
  ObligationRead: "obligation.read",
  ObligationWrite: "obligation.write",
  SystemHealthRead: "systemhealth.read",

  // Bản tin AI cảnh báo quản lý (QĐ 0428) — màn "Việc cần xem".
  AiBriefingReadOwn: "ai_briefing.read_own",
  AiBriefingHandle: "ai_briefing.handle",
  AiBriefingOversee: "ai_briefing.oversee",
  // Kho Ý Tưởng liên ngành (QĐ 0445) — chỉ CEO + giám đốc.
  IdeaBankRead: "idea_bank.read",
  IdeaBankGrade: "idea_bank.grade",
  // Bàn điều hành quản lý (CEO chốt 20/10/2026) — tầng "Cần xử lý ngay".
  OpsBoardRead: "opsboard.read",
  // Hiệu suất quản lý (CEO chốt 28/10/2026).
  MgmtPerfRead: "mgmtperf.read",

  // Letan
  LetanApprove: "letan.approve",
  // Xác nhận lịch ngày mai (QĐ 0321 · M4) — máy chủ gác thêm theo phòng lễ tân.
  ConfirmCallRead: "confirmcall.read",
  ConfirmCallWrite: "confirmcall.write",
  // Dịp chụp của đơn + đếm lời khách chưa sửa (QĐ 0480) — phạm vi cơ sở kiểm ở máy chủ.
  OrderOccasionRead: "order.occasion.read",
  OrderOccasionWrite: "order.occasion.write",

  // Ekip shift — đăng ký ca tuần photo/makeup. Ba action riêng vì đọc, tự
  // đăng ký và duyệt là ba khả năng khác nhau. Role map ở BE cố ý rộng
  // (RoleStaff dùng chung nhiều phòng), service mới là chốt theo phòng ban —
  // các hàm canXxx trong features/ekip-shift/permissions.ts soi gương logic đó.
  EkipShiftRead: "ekipshift.read",
  EkipShiftRegister: "ekipshift.register",
  EkipShiftApprove: "ekipshift.approve",

  // Báo nghỉ — mô hình NGƯỢC với đăng ký ca (CEO 03/09/2026): mặc định có
  // mặt, chỉ khai ngày nghỉ. Ba danh sách vai KHÁC NHAU ở BE, cố ý: trưởng
  // cửa hàng DUYỆT được mà KHÔNG nộp được đơn (họ không nằm trong ê-kíp),
  // còn quản lý cụm chỉ ĐỌC. Đừng gộp ba cái thành một cờ "quản lý ca".
  EkipAbsenceRead: "ekipabsence.read",
  EkipAbsenceWrite: "ekipabsence.write",
  EkipAbsenceApprove: "ekipabsence.approve",

  // Order
  OrderWrite: "order.write",
  OrderDelete: "order.delete",
  // "📣 Báo đã mở lịch" cho khách đã cọc chờ lịch (QĐ 0489).
  OrderScheduleWaitAnnounce: "order.schedule_wait.announce",
  OrderSurchargeWrite: "order.surcharge.write",
  OrderSurchargeDelete: "order.surcharge.delete",
  OrderSurchargeApprove: "order.surcharge.approve",
  // Duyệt giao vượt số ảnh của gói (tách khỏi duyệt giá phát sinh 17/10/2026, CEO chốt Q03).
  RetouchQuotaOverride: "retouch.quota.override",
  OrderPackageUpgradeWrite: "order.package_upgrade.write",
  OrderManualDiscountWrite: "order.manual_discount.write",
  // Đơn giá thợ riêng trên đơn doanh nghiệp (QĐ 0105) — trưởng cửa hàng /
  // giám đốc / quản trị; đi thẳng vào máy lương nên tách khỏi order.write.
  OrderCrewRateWrite: "order.crew_rate.write",
  // Duyệt báo giá doanh nghiệp (QĐ 0178). Tách khỏi order.write vì người
  // DỰNG báo giá không được là người CHỐT nó — cùng lẽ với banktx.approve.
  OrderQuoteApprove: "order.quote.approve",

  // Photo — luồng khách chọn ảnh trên iPad (đơn ảnh thẻ)
  PhotoUpload: "photo.upload",
  PhotoRead: "photo.read",
  AlbumShareWrite: "album.share.write",
  PhotoSessionWrite: "photo.session.write",
  PhotoSessionReopen: "photo.session.reopen",
  PhotoRetouchRead: "photo.retouch.read",
  PhotoRetouchWrite: "photo.retouch.write",
  PhotoRetouchTransfer: "photo.retouch_transfer",
  // Ảnh IN của đơn — bộ RIÊNG, không phải ảnh buổi chụp. Action riêng chứ
  // không dùng lại photo.upload vì danh sách phòng khác hẳn ở cả hai đầu: ảnh
  // in mở cho hậu kỳ và CSKH, đóng với lễ tân.
  PhotoPrintWrite: "photo.print.write",

  // Gallery Profile/Doanh nghiệp. Quyền settings cố ý admin-only; các cửa
  // vận hành còn được backend mở theo phòng ban và kiểm tra assignment.
  GalleryRead: "gallery.read",
  GalleryAlbumWrite: "gallery.album.write",
  GalleryAssetWrite: "gallery.asset.write",
  GalleryShareWrite: "gallery.share.write",
  GalleryCommentWrite: "gallery.comment.write",
  GallerySelectionWrite: "gallery.selection.write",
  GallerySelectionUnlock: "gallery.selection.unlock",
  // Mở lại ảnh gốc hết hạn thêm 7 ngày (QĐ 0459). CSKH vào bằng phòng ban.
  GalleryOriginalsReopen: "gallery.originals.reopen",
  GallerySettingsWrite: "gallery.settings.write",
  // Xưởng ghép + tranh màu nước ở nhánh Final (QĐ 0233). Hậu kỳ/CSKH vào bằng
  // phòng ban (features/gallery/permissions.ts), không bằng quyền này.
  GalleryComposeWrite: "gallery.compose.write",
  GalleryWatercolorRun: "gallery.watercolor.run",
  GalleryWatercolorCostRead: "gallery.watercolor.cost.read",
  // Kho ảnh nền Xưởng ghép "Câu chuyện" (QĐ 0353): đọc cho người dùng Xưởng ghép, quản lý cho marketing + quản lý.
  ComposeBackdropRead: "compose.backdrop.read",
  ComposeBackdropManage: "compose.backdrop.manage",
  // Album ngoài đơn (QĐ 0306): tạo — phòng ảnh / marketing / sale vào bằng
  // phòng ban (features/album-manager/permissions.ts); sổ giám đốc — chỉ ban giám đốc.
  GalleryLooseCreate: "gallery.loose.create",
  GalleryLooseAudit: "gallery.loose.audit",

  // Payment
  PaymentAdd: "payment.add",
  PaymentApprove: "payment.approve",

  // Payroll
  PayrollRead: "payroll.read",
  PayrollFinalize: "payroll.finalize",
  PayrollCenterStatusRead: "payroll.center_status.read",
  PayrollTrainingFeeRead: "payroll.training_fee.read",
  // Bảng xem trước tác động khi bật cơ chế bậc tay nghề (quyết định 0104).
  // Cổng RIÊNG, hẹp hơn payroll.read: bảng chạy toàn hệ, không có rào chi
  // nhánh — cấp bằng payroll.read là để trưởng cửa hàng đọc lương cơ sở khác.
  PayrollCraftPreview: "payroll.craft.preview",
  // Thẻ "Lương" trong chi tiết đơn — tiền công từng người trên một đơn, chỉ
  // admin + director (cổng riêng, không dùng payroll.read).
  PayrollOrderLinesRead: "payroll.order_lines.read",
  // Bảng soi nâng gói — cổng RIÊNG, không dùng payroll.read: người xem là
  // quản lý vận hành, không nhất thiết là người được đọc lương. Cố ý KHÔNG
  // cấp cho sale/điều phối dù họ nâng gói được, vì cấp cho người bị soi là
  // hỏng mục đích (quyết định 0039).
  ReportUpsellRead: "report.upsell.read",

  // Sổ từng job Hậu kỳ + CSKH. Xem sổ của CHÍNH MÌNH không cần quyền nào
  // (endpoint /work-ledger/me tự thu về người gọi) — ba quyền dưới đây là để
  // xem/sửa của người khác.
  WorkLedgerRead: "workledger.read",
  WorkLedgerWrite: "workledger.write",
  WorkLedgerRebuild: "workledger.rebuild",

  // Retouch
  RetouchWrite: "retouch.write",
  RetouchComplete: "retouch.complete",
  RetouchReview: "retouch.review",

  // Salary — Component
  SalaryComponentRead: "salary.component.read",
  SalaryComponentWrite: "salary.component.write",
  // Salary — Confirmation
  SalaryConfirmationRead: "salary.confirmation.read",
  SalaryConfirmationSend: "salary.confirmation.send",
  SalaryConfirmationDelete: "salary.confirmation.delete",
  // Salary — Custom entry
  SalaryCustomEntryRead: "salary.customentry.read",
  SalaryCustomEntryWrite: "salary.customentry.write",
  // Salary — Notification
  SalaryNotificationRead: "salary.notification.read",
  SalaryNotificationWrite: "salary.notification.write",
  SalaryNotificationDelete: "salary.notification.delete",
  // Salary — Proposal
  SalaryProposalRead: "salary.proposal.read",
  SalaryProposalWrite: "salary.proposal.write",
  SalaryProposalReview: "salary.proposal.review",
  // Salary — Rule
  SalaryRuleRead: "salary.rule.read",
  SalaryRuleWrite: "salary.rule.write",
  SalaryRuleDelete: "salary.rule.delete",
  // Salary — Rule v2 (biểu giá theo phòng, salary_rules_v2)
  SalaryRuleV2Read: "salary.rulev2.read",
  SalaryRuleV2Write: "salary.rulev2.write",
  // Salary — Staff override (điều chỉnh delta theo từng nhân sự)
  SalaryStaffOverrideRead: "salary.staffoverride.read",
  SalaryStaffOverrideWrite: "salary.staffoverride.write",

  // Schedule
  ScheduleWrite: "schedule.write",
  ScheduleSettingsWrite: "schedule.settings.write",

  // Sổ khách bí mật (M7) — trang kín /spot-checks, chỉ admin/giám đốc.
  // Một action gác cả đọc lẫn ghi; tuyệt đối không đưa trang lên menu.
  SpotcheckManage: "spotcheck.manage",
  FraudRead: "fraud.read",
  SalaryAlertThresholdWrite: "salary.alert.threshold.write",
  RiskSignalVoid: "risksignal.void",

  // Chốt két tiền mặt. `Operate` KHÔNG đủ để biết ai thao tác được: backend
  // dùng AllowOrDept("cashdrawer.operate", "reception") nên lễ tân qua được
  // dù vai `staff` không có action nào — xem permissions.ts của feature, đừng
  // gọi hasPermission trực tiếp. `Confirm` cố ý tách khỏi `Operate`: chữ ký
  // thứ hai phải là người khác người đếm. `Remit` là nộp tiền vào ngân hàng
  // (KHÔNG phải tiền cọc của khách).
  CashdrawerOperate: "cashdrawer.operate",
  CashdrawerConfirm: "cashdrawer.confirm",
  CashdrawerRemit: "cashdrawer.remit",
  CashdrawerRead: "cashdrawer.read",
  // Bảng điều phối khách ảnh thẻ tại cơ sở. Gác nửa "lễ tân" của bảng; nhân
  // sự makeup/photo KHÔNG cần action này — họ chỉ bấm Xong cho khách của
  // chính mình, backend tự kiểm theo tên người được gán.
  StoreboardManage: "storeboard.manage",
  // Bảng set chụp. Operate là cổng thô, máy chủ soát thêm ekip, ca trưởng, trợ lý.
  SetBoardRead: "set_board.read",
  SetBoardOperate: "set_board.operate",
  SetBoardLayout: "set_board.layout",

  // Máy chia đơn Profile cho thợ chụp/trang điểm (quyết định 0077). Gác nửa
  // "quản lý" của máy: DispatchRead + DispatchOverride gác bảng suất cơ sở
  // (Việc 14), DispatchConfigWrite gác màn cài đặt của admin/giám đốc.
  // Nhân sự xem suất của CHÍNH MÌNH KHÔNG cần action nào — /dispatch/my là
  // auth-only, khuôn /store-board/my.
  // DispatchRespond (trả suất / nhặt suất, Việc 13) là gate THÔ: backend mới
  // là nơi kiểm chỉ-người-đang-giữ mới trả được.
  DispatchRead: "dispatch.read",
  DispatchRespond: "dispatch.respond",
  DispatchOverride: "dispatch.override",
  DispatchConfigWrite: "dispatch.config.write",
  // Sổ điểm hành vi (03/09/2026): CHỈ quản lý mới đọc được điểm của người
  // khác. Nhân sự xem điểm CỦA MÌNH qua /dispatch/my-points — cửa auth-only,
  // không cần action, cùng khuôn với /dispatch/my.
  DispatchPointsRead: "dispatch.points.read",
  // DispatchPointsVoid — nút "Gỡ phạt" trên màn Điểm hành vi (QĐ 0142 §6.3,
  // CEO chốt 16/09/2026). Hẹp hơn DispatchPointsRead đúng MỘT vai: quản lý
  // cụm đọc được sổ điểm nhưng KHÔNG gỡ được — họ giám sát, không vận hành.
  DispatchPointsVoid: "dispatch.points.void",
  // Bảng người được chỉ định cho nhãn khó, khai theo TỪNG cơ sở. Hẹp hơn
  // DispatchOverride một bậc: trưởng cửa hàng khai được cho cơ sở mình, còn
  // trưởng phòng thì KHÔNG — người được chỉ định là quyết định của cơ sở.
  DispatchDesigneeWrite: "dispatch.designee.write",

  // Nhãn đơn — GẮN và GỠ là hai quyền khác nhau, cố ý (CEO chốt 03/09/2026).
  // Cả ê-kíp gắn được nhãn (thấy đơn khó thì đánh dấu ngay), nhưng chỉ quản
  // lý mới gỡ: nhãn khó khoá đơn vào nhóm người được chỉ định, gỡ nhãn là mở
  // khoá đó ra. Backend gác GỠ bằng cách so danh sách nhãn trước/sau, nên
  // giao diện phải khoá nút gỡ cho khớp — không thì nhân sự bấm rồi ăn 403.
  // OrderTagManage gác DANH MỤC nhãn (thêm/sửa/tắt nhãn của cả hệ).
  OrderTagAdd: "order.tag.add",
  OrderTagRemove: "order.tag.remove",
  OrderTagManage: "ordertag.manage",
  // DispatchSweep — nút "Rà lại ngay" trên màn cài đặt. Cùng tập vai với
  // DispatchConfigWrite nhưng là action RIÊNG: rà tay gán người thật và bắn
  // thông báo thật cho thợ, không phải ghi cấu hình.
  DispatchSweep: "dispatch.sweep",
  // DispatchAutoAcceptWrite — công tắc "Tự động nhận suất máy giao" trên màn
  // Suất của tôi (QĐ 0142 §6.4). Ai cũng mang quyền; máy chủ mới rào "chỉ CTV".
  DispatchAutoAcceptWrite: "dispatch.auto_accept.write",
  // DispatchWhyRead — mục "Vì sao tôi chưa được suất?" trên màn Suất của tôi
  // (QĐ 0142 §7.2). Cùng tập vai với DispatchRespond; máy chủ chỉ trả dòng
  // của chính người gọi.
  DispatchWhyRead: "dispatch.why.read",
  // DispatchBranchLoadRead — bảng lệch tải theo cơ sở (Việc 17). Action RIÊNG
  // chứ KHÔNG dùng lại DispatchRead: bảng này để quản lý cụm nhìn cả cụm mà
  // điều người, nhưng dispatch.read KHÔNG có area_manager. Gộp vào đó là hoặc
  // nới dispatch.read cho cả cụm, hoặc bỏ đúng người cần bảng này.
  DispatchBranchLoadRead: "dispatch.branchload.read",
  // Sổ việc nhận (QĐ 0254): thợ tự chọn loại việc (thẻ "Việc tôi nhận" trên
  // Tổng quan); quản lý xem + tích hộ (khối trong Hồ sơ, thẻ "Việc nhận" trang Nhân sự).
  JobChoiceSelfWrite: "jobchoice.self.write",
  JobChoiceStaffRead: "jobchoice.staff.read",
  JobChoiceStaffWrite: "jobchoice.staff.write",
  // Hộp thư kín "Tố giác & Góp ý" (QĐ 0272). read/readersWrite là lớp thô —
  // máy chủ còn gác bằng TÊN (danh sách người đọc).
  SealedInboxSubmit: "sealedinbox.submit",
  SealedInboxRead: "sealedinbox.read",
  SealedInboxReadersWrite: "sealedinbox.readers.write",
  // Phòng máy của lõi chân dung khách (QĐ 0541). Lớp thô — máy chủ gác bằng TÊN
  // (bảng người trong phòng: CEO + đúng một người CEO chỉ định).
  HunchRoomEnter: "hunchroom.enter",
  // Máy chia việc sửa hình (quyết định 0090). Respond là gate THÔ: backend gác
  // thêm phòng hậu kỳ + chỉ chủ lời chào mới Nhận/Bận được. ConfigWrite với
  // manager chỉ khi là trưởng nhóm sửa hình — cũng backend gác.
  RetouchDispatchRespond: "retouch.dispatch.respond",
  RetouchDispatchRead: "retouch.dispatch.read",
  RetouchDispatchConfigWrite: "retouch.dispatch.config.write",
  // Chứng chỉ chuyên ngành MasterClass — QĐ 0101 (06/09/2026)
  CertgateRead: "certgate.read",
  CertgateConfigWrite: "certgate.config.write",
  CertgateException: "certgate.exception",

  // Khách chấm điểm ê-kíp + tiền tip (quyết định 0032). FlagDecide: manager
  // còn bị backend gate đúng bộ phận của cờ — role map chỉ là tầng thô.
  ReviewRead: "review.read",
  ReviewFlagDecide: "review.flag.decide",
  ReviewExclude: "review.exclude",
  ReviewAudit: "review.audit",
  ReviewConfigWrite: "review.config.write",
  TipsRead: "tips.read",
  TipsAssign: "tips.assign",

  // Module ca vận hành cơ sở (spec 20/08/2026). `Operate` cấp rộng theo role
  // vì ca trưởng là nhân sự bất kỳ — BE mới là chốt: chỉ lead của ĐÚNG ca
  // (hoặc trưởng cửa hàng chi nhánh đó) thao tác được. FE dùng các key này
  // để ẩn/hiện tab; đừng suy "có operate = bấm được mọi ca".
  BranchShiftRead: "branchshift.read",
  BranchShiftPlan: "branchshift.plan",
  /**
   * Duyệt / trả lại sổ SỐ MẶT trang điểm của một buổi (quyết định 0194 điều 5).
   *
   * Trưởng cửa hàng · Quản lý cụm · Giám đốc · Quản trị. KHÔNG có Trưởng phòng,
   * dù vai đó ghi được sổ công doanh nghiệp — người chốt 25/09/2026 nói thẳng
   * "không còn trưởng phòng trang điểm nữa".
   */
  MakeupFacesApprove: "order.makeupfaces.approve",
  /** Thợ trang điểm khai số mặt CỦA CHÍNH MÌNH trên một buổi (QĐ 0194 điều 5). */
  MakeupFacesSelf: "order.makeupfaces.self",
  BranchShiftOperate: "branchshift.operate",
  BranchShiftReview: "branchshift.review",
  HalfDaySlotRead: "half_day_slot.read",
  HalfDaySlotWrite: "half_day_slot.write",
  HalfDaySlotReport: "half_day_slot.report",
  ShiftTemplateRead: "shifttemplate.read",
  ShiftTemplateWrite: "shifttemplate.write",
  IncidentRead: "incident.read",
  IncidentWrite: "incident.write",
  IncidentAck: "incident.ack",
  // Đổi trạng thái phiếu lỗi (resolved/verified) — TÁCH khỏi IncidentWrite là
  // quyền LẬP phiếu. Quản lý cụm có quyền này mà không có quyền lập phiếu:
  // cửa "Xác minh" là việc của tầng cụm, cửa "ghi sổ lỗi" là việc của cơ sở.
  IncidentStatusWrite: "incident.status.write",
  // Định giá ba mốc phạt lỗi (quyết định 0074) — admin/giám đốc, KHÔNG có qc.
  IncidentPenaltyConfigWrite: "incident.penalty.config.write",

  // ─── Khung hiệu suất 100 điểm + quỹ KPI (spec 28/08, quyết định 0076) ────
  //
  // Bốn quyền tách rời có chủ đích, và ranh giữa chúng CHÍNH LÀ ràng buộc
  // "kín thông tin" của CEO (spec 8.1b):
  //
  //   PerformanceReadSelf     — mọi người, nhưng cửa chỉ trả hồ sơ CỦA CHÍNH
  //                             người gọi (danh tính từ JWT, không nhận staffId)
  //   PerformanceReadCriteria — tiêu chí + mã lỗi NGHỀ MÌNH
  //   PerformanceReadTeam     — bảng cả đội, backend cắt theo BranchScope
  //   PerformanceConfigWrite  — TRỌN BỘ tiêu chí mọi nghề (tài sản vận hành):
  //                             gác cả chiều ĐỌC, chỉ admin/giám đốc
  PerformanceReadSelf: "performance.read.self",
  // Đồ mượn Kiểm kê (CEO chốt 1a · 2a, 29/09/2026): đồ CỦA CHÍNH người gọi
  // (thẻ "Đồ đang mượn" ở Hiệu suất của tôi) và báo cáo quá hạn cho quản lý
  // (trang "Đồ quá hạn", máy chủ cắt theo phạm vi cơ sở).
  EquipmentLoanReadSelf: "equipment_loan.read.self",
  EquipmentLoanOverdueRead: "equipment_loan.overdue.read",
  // Mục Kho (kho-erp v1): xem mục Kho / gửi lệnh sang kho GNW.
  KhoRead: "kho.read",
  KhoCommand: "kho.command",
  KhoKitWrite: "kho.kit.write",
  // Báo cáo trang phục Kho (QĐ 0267): thẻ "Tình hình đồ" ở Concept & Trang
  // phục + ô nhắc thiếu đồ ở Dashboard; máy chủ cắt theo phạm vi cơ sở.
  WardrobeReportRead: "wardrobe.report.read",
  // Tra đồ trong kho (QĐ 0538): xem đồ mọi cơ sở, ghim đồ vào đơn, lưu số đo khách.
  WardrobeLookupRead: "wardrobe.lookup.read",
  WardrobePickWrite: "wardrobe.pick.write",
  CustomerBodyWrite: "customer.body.write",
  PerformanceReadCriteria: "performance.read.criteria.own",
  PerformanceReadTeam: "performance.read.team",
  PerformanceConfigWrite: "performance.config.write",
  // Ảnh mẫu theo bậc của tiêu chí chấm QC (chấm QC bản 3) — quản trị, giám đốc.
  PerformanceRubricExamplesManage: "performance.rubric_examples.manage",
  // Người chấm chuẩn của hiệu chuẩn QC + công tắc chấm QC bản 3 — quản trị, giám đốc.
  PerformanceQcCalibrationManage: "performance.qc_calibration.manage",
  PerformanceQcAuditRead: "performance.qc_audit.read",
  PerformanceQcAuditWrite: "performance.qc_audit.write",
  PerformanceReviewWrite: "performance.review.write",
  // Phiếu KÉO KHÁCH — trưởng cửa hàng tick tháng (chủ studio chốt
  // 07/09/2026). Quyền RIÊNG, không dùng lại performance.review.write:
  // danh sách vai khác hẳn (có trưởng cửa hàng và quản lý cụm, KHÔNG có
  // QC), mà gộp thì mở cho QC chấm thứ họ không quan sát được.
  PerformanceGrowthWrite: "performance.growth.write",
  // Phiếu đồng phục (QĐ 0244): trưởng cửa hàng, QC, quản lý cụm cùng chấm.
  PerformanceUniformWrite: "performance.uniform.write",
  // Trang "Điểm cơ sở" + lịch sử lượt kiểm cơ sở vật chất (QĐ 0246).
  PerformanceBranchScoreRead: "performance.branchscore.read",
  PerformanceKudosWrite: "performance.kudos.write",
  // Sổ quỹ phạt công khai — mọi người xem được, máy chủ trả về đã ẩn danh.
  PenaltyFundRead: "penalty.fund.read",

  // Đợt 3 — nối tiền, chu kỳ, phúc khảo.
  //
  // AppealWrite mở cho mọi vai vì spec gọi phúc khảo là "đệm chống oan DUY
  // NHẤT" (tháng đầu trừ thật ngay, không chạy nháp); service gác tiếp: chỉ
  // chủ phiếu, và chỉ trong 3 ngày kể từ lúc xác nhận.
  //
  // AppealDecide CỐ Ý không có qc và branch_manager: người ghi lỗi (và quản
  // lý trực tiếp của người ghi) không tự xử đơn kêu oan về lỗi mình ghi.
  PerformanceAppealWrite: "performance.appeal.write",
  PerformanceAppealDecide: "performance.appeal.decide",
  PerformanceCycleWrite: "performance.cycle.write",
  PerformancePolicyAck: "performance.policy.ack",
  PenaltyFundSpendWrite: "penalty.fund.spend.write",

  // Đợt 4 — đồng đội, vãng lai, bằng chứng, cờ bất thường.
  PerformancePeerWrite: "performance.peer.write",
  PerformanceWalkinWrite: "performance.walkin.write",
  PerformanceEvidenceWrite: "performance.evidence.write",
  PerformanceEvidenceApprove: "performance.evidence.approve",
  PerformanceFraudRead: "performance.fraud.read",

  // Đợt 5 — mốc tháng, sổ đỏ, sổ marketing.
  PerformanceTargetWrite: "performance.target.write",
  PerformanceRedMonthRead: "performance.redmonth.read",
  PerformanceMarketingWrite: "performance.marketing.write",

  // Đợt 6 — điểm đơn, vòng đào tạo.
  PerformanceOrderRead: "performance.order.read",
  PerformanceTrainingWrite: "performance.training.write",

  // Đợt 7 — vinh danh, mô phỏng, hồ sơ bậc nghề.
  PerformanceLeaderboardRead: "performance.leaderboard.read",
  PerformanceSimulate: "performance.simulate",
  PerformanceDossierRead: "performance.dossier.read",

  // Tab "Phân tích kinh doanh" của Marketing (spec 29/08/2026). Hai quyền
  // tách nhau CÓ CHỦ Ý: Read mở cho trưởng cửa hàng — họ xem bốn khu số liệu
  // vận hành nhưng phạm vi bị BE cắt về cơ sở của họ; Sensitive giữ riêng khu
  // tiền quảng cáo cho MKT và ban giám đốc. Gộp một quyền là hoặc giấu số vận
  // hành khỏi người cần nó, hoặc mở sổ chi tiêu ads cho cả chuỗi.
  MarketingAnalyticsRead: "marketing.analytics_read",
  MarketingAnalyticsSensitive: "marketing.analytics_sensitive",

  // Chuông trong app — ba cửa /notifications*. Mọi vai đang hoạt động đều có.
  NotificationRead: "notification.read",

  // Năng suất nhân sự (QĐ 0386). Read mở cửa trang; ai thấy ai do máy chủ cắt
  // (lead phòng mình, trưởng cửa hàng cơ sở mình, giám đốc tất cả).
  // CapacityWrite = đặt trần nhận việc — lead và điều hành, KHÔNG có QC và
  // trưởng cửa hàng.
  StaffProductivityRead: "staff_productivity.read",
  StaffProductivityCapacityWrite: "staff_productivity.capacity_write",

  // Khung xếp hạng & bộ sưu tập (spec 17/10/2026). Read: thấy khung của mọi
  // người + mở trang Bộ sưu tập. Equip: đổi món đeo của chính mình (viewer
  // chỉ xem, không có quyền này).
  CosmeticsRead: "cosmetics.read",
  CosmeticsEquip: "cosmetics.equip",
} as const;

export type Action = (typeof ACTION)[keyof typeof ACTION];
